import ContentFrame from "./components/ContentFrame";

const TaskGroupsBar = () => {
    return <ContentFrame />;
};

export default TaskGroupsBar;
